document.addEventListener('DOMContentLoaded', function () {
	function getCurrentOpeningsById() {
		const cmbteams = document.getElementById('cmbteams').value;
		const cmbexp = document.getElementById('cmbexp').value;
		const cmbcountry = document.getElementById('cmbcountry').value;
		const hdnAttributes = document.getElementById('hdnAttributes').value;
		// Function to validate the file size
		function validateFileSize(fileInput) {
			const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB in bytes
			const fileSize = fileInput.files[0].size;
			return fileSize <= maxSizeInBytes;
		}
		function validateFileFormat(fileInput) {
			const allowedFormats = [
				'pdf',
				'doc',
				'docx',
				'ppt',
				'pptx',
				'jpg',
				'jpeg',
				'png',
				'gif',
				'zip',
				'webp',
			];
			const fileName = fileInput.value.toLowerCase();
			const fileExtension = fileName.split('.').pop();
			return allowedFormats.includes(fileExtension);
		}
		function validateForm(
			concentValidation,
			fileValidationMessage,
			isCheckedConcent,
			resumeFile,
			fileSizeValidationMessage,
			fileExsistsValidationMessage,
			selectElement,
		) {
			const resumeInput = resumeFile;
			const validationConcent = concentValidation;
			const fileValidation = fileValidationMessage;
			const sizeValidation = fileSizeValidationMessage;
			const fileExsists = fileExsistsValidationMessage;
			const requiredInputs = document.querySelectorAll('.contact-dynamic input[required]');
			let empty = true;
			if (selectElement) {
				const selectValue = selectElement.value;
				const text = document.createElement('p');
				text.classList.add('contact-error');
				if (!selectValue) {
					empty = false;
				}
				if (!selectValue && !selectElement.nextElementSibling) {
					empty = false;
					const errorMessage = 'Please fill the required fields';
					const textContent = document.createTextNode(errorMessage);
					text.appendChild(textContent);
					selectElement.parentNode.appendChild(text);
				} else if (selectValue && selectElement.nextElementSibling) {
					selectElement.nextElementSibling.remove();
				}
			}
			requiredInputs.forEach(function (input) {
				const isChecked = isCheckedConcent.checked;
				const text = document.createElement('p');
				text.classList.add('contact-error');
				const val = input.value.trim();
				if (input.type !== 'checkbox' && input.type !== 'file' && input.nextElementSibling) {
					input.nextElementSibling.remove();
				}
				if ((val.length === 0 || typeof val === 'undefined') && input.type !== 'file') {
					empty = false;
					const errorMessage = 'Please fill the required fields';
					const textContent = document.createTextNode(errorMessage);
					text.appendChild(textContent);
					input.parentNode.appendChild(text);
				}
				if (!resumeInput.files[0]) {
					fileExsists.style.display = 'block';
					empty = false;
				}
				if (input.type === 'file' && resumeInput.files[0]) {
					fileExsists.style.display = 'none';
					const fileSize = validateFileSize(resumeInput);
					const fileFormat = validateFileFormat(resumeInput);
					if (fileSize === false) {
						sizeValidation.style.display = 'block';
						empty = false;
					} else {
						sizeValidation.style.display = 'none';
					}
					if (fileFormat === false) {
						fileValidation.style.display = 'block';
						empty = false;
					} else {
						fileValidation.style.display = 'none';
					}
				}
				if (input.type === 'checkbox' && !isChecked) {
					empty = false;
					validationConcent.style.display = 'block';
				} else if (input.type === 'checkbox' && isChecked) {
					validationConcent.style.display = 'none';
				}
			});
			return empty;
		}
		function copyCareerLink(copyLink) {
			const tooltip = copyLink;
			const link = copyLink.firstChild.getAttribute('href');
			const tempTextarea = document.createElement('textarea');
			tempTextarea.value = link;
			document.body.appendChild(tempTextarea);
			tempTextarea.select();
			document.execCommand('copy');
			document.body.removeChild(tempTextarea);
			tooltip.children[2].style.visibility = 'visible';
			setTimeout(function () {
				tooltip.children[2].style.visibility = 'hidden';
			}, 2000);
		}
		const xhr = new XMLHttpRequest();
		xhr.open('POST', ajaxload_params.ajaxurl); //eslint-disable-line
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.onload = function () {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.responseText);
				if (response) {
					document.querySelector('#inner-html').remove();
					document.querySelector('.medium-uppercase').textContent = '';
					document
						.querySelector('#openings-structure')
						.insertAdjacentHTML('beforeend', response.html);

					document
						.querySelector('.medium-uppercase')
						.insertAdjacentHTML('beforeend', response.count_post);

					const currentOpenings = document.querySelectorAll('.current-opening-dropdown.item');
					currentOpenings.forEach(currentOpening => {
						const openingContainer = currentOpening.querySelector('.opening-container');
						openingContainer.addEventListener('click', () => {
							const clsIna = currentOpening.querySelector('.detail-container').classList;
							if (clsIna.contains('inactive')) {
								currentOpening.querySelector('.detail-container').classList.remove('inactive');
								currentOpening.querySelector('.carat-sign').classList.add('open');
								currentOpening.classList.add('open-dropdown');
							} else {
								currentOpening.querySelector('.detail-container').classList.add('inactive');
								currentOpening.querySelector('.carat-sign').classList.remove('open');
								currentOpening.classList.remove('open-dropdown');
							}
						});
					});

					const loadMore = document.querySelector('.load-more');
					if (loadMore) {
						loadMore.addEventListener('click', event => {
							let cnt = 0;
							event.preventDefault();
							while (cnt < 5) {
								const row = document.querySelector('.current-opening-dropdown.inactive');
								if (row !== null) {
									document
										.querySelector('.current-opening-dropdown.inactive')
										.classList.remove('inactive');
								} else {
									console.error("Element with class 'my-class' not found.");
									document.querySelector('.openings-button').classList.add('inactive');
								}
								cnt += 1;
							}
						});
					}
					/* Commenting because of multiple ajax call */
					// document.addEventListener('click', () => {
					// 	const cmblocation = document.querySelectorAll('.input-filter select');
					// 	cmblocation.forEach(cmbdrp => {
					// 		cmbdrp.addEventListener('change', event => {
					// 			event.preventDefault();
					// 			getCurrentOpeningsById();
					// 		});
					// 	});
					// });
					/* Commenting because of multiple ajax call */
				}
				const jobOpeningElements = document.querySelectorAll('.current-opening-dropdown.item');
				const applicationCompleteClose = document.getElementById('complete-close');
				const applicationCompleteCloseButton = document.getElementById('complete-close-button');
				const applicationComplete = document.querySelector('.application-modal-index');

				applicationCompleteClose.addEventListener('click', () => {
					applicationComplete.style.display = 'none';
					document.body.classList.remove('scroll-fix');
					window.location.reload();
				});
				applicationCompleteCloseButton.addEventListener('click', () => {
					applicationComplete.style.display = 'none';
					document.body.classList.remove('scroll-fix');
					window.location.reload();
				});

				jobOpeningElements.forEach(jobOpeningElement => {
					const formSubmitCurrentOpening = jobOpeningElement.querySelector(
						'#formSubmitCurrentOpening',
					);
					const fileValidationMessage = jobOpeningElement.querySelector('.validated-file');
					const careerIndexModal = jobOpeningElement.querySelector('.career-modal');
					const form = jobOpeningElement.querySelector('.career-form-index');
					const formSubmit = jobOpeningElement.querySelector('#formSubmitIndex');
					const uploadButton = jobOpeningElement.querySelector('.resume-upload-index');
					const resumeFile = jobOpeningElement.querySelector('.resume-index');
					const fileNameDisplay = jobOpeningElement.querySelector('#file-name-index');
					const copyLink = jobOpeningElement.querySelectorAll('.copyLink');
					const concentValidation = jobOpeningElement.querySelector('.consent-validation-index');
					const isCheckedConcent = jobOpeningElement.querySelector('.consent-index');
					const fileSizeValidationMessage = jobOpeningElement.querySelector('.validated-file-size');
					const fileExsistsValidationMessage = jobOpeningElement.querySelector(
						'.validated-file-exsists',
					);
					const selectElement = jobOpeningElement.querySelector('.experience-index');
					const formApplyButtonText = jobOpeningElement.querySelector('.form-button-apply');
					if (concentValidation) {
						concentValidation.style.display = 'none';
					}
					if (fileValidationMessage) {
						fileValidationMessage.style.display = 'none';
					}
					if (fileSizeValidationMessage) {
						fileSizeValidationMessage.style.display = 'none';
					}
					if (fileExsistsValidationMessage) {
						fileExsistsValidationMessage.style.display = 'none';
					}
					copyLink.forEach(function (copy) {
						copy.addEventListener('click', () => {
							copyCareerLink(copy);
						});
					});
					formSubmitCurrentOpening.addEventListener('click', () => {
						const careerPopup = careerIndexModal;
						form.classList.add('contact-dynamic');
						careerPopup.style.display = 'block';
						document.body.classList.add('scroll-fix');
					});
					const closeIcon = jobOpeningElement.querySelector('#close-icon-index');
					closeIcon.addEventListener('click', () => {
						const careerPopup = careerIndexModal;
						form.classList.remove('contact-dynamic');
						careerPopup.style.display = 'none';
						document.body.classList.remove('scroll-fix');
					});
					formSubmit.addEventListener('click', () => {
						const careerPopup = careerIndexModal;
						if (
							validateForm(
								concentValidation,
								fileValidationMessage,
								isCheckedConcent,
								resumeFile,
								fileSizeValidationMessage,
								fileExsistsValidationMessage,
								selectElement,
							) === true
						) {
							formApplyButtonText.textContent = 'Applying...';
							formApplyButtonText.setAttribute('disabled', true);
							const formdata = new FormData();
							const file = resumeFile.files[0];
							const recaptchaToken = document.getElementById('recaptcha_token');
							formdata.append('file', file); // phpcs:ignore.
							formdata.append('name', form.first_name.value); // phpcs:ignore.
							formdata.append('lastname', form.last_name.value); // phpcs:ignore.
							formdata.append('email', form.email.value); // phpcs:ignore.
							formdata.append('mobile', form.mobile_number.value); // phpcs:ignore.
							formdata.append('experience', form.experience.value); // phpcs:ignore.
							formdata.append('nonce', form.nonce.value); // phpcs:ignore.
							formdata.append('role', form.role.value); // phpcs:ignore.
							formdata.append('location', form.location.value); // phpcs:ignore.
							formdata.append('careerid', form.careerid.value); // phpcs:ignore.
							formdata.append('toMail', form.toMail.value); // phpcs:ignore.
							formdata.append('recaptcha', recaptchaToken.value); // phpcs:ignore.
							formdata.append('action', 'career_form');

							fetch(
								ajaxload_params.ajaxurl, // eslint-disable-line
								{
									method: 'POST',
									body: formdata,
								},
							)
								.then(result => {
									if (!result.ok) {
										throw new Error('Network response was not ok');
									}
									return result.json(); // Parse the JSON response
								})
								.then(data => {
									console.log(data);
									if (data.success) {
										careerPopup.style.display = 'none';
										applicationComplete.style.display = 'flex';
										document.body.classList.add('scroll-fix');
									} else {
										console.error('Upload Failed:', data.message);
									}
								})
								.catch(error => {
									console.error('Error:', error);
								});
						}
					});
					uploadButton.addEventListener('click', () => {
						const fileInput = uploadButton.previousElementSibling;
						const fileName = fileNameDisplay;
						fileInput.click();
						fileInput.addEventListener('change', function () {
							const selectedFile = fileInput.files[0];
							if (selectedFile) {
								fileName.textContent = selectedFile.name;
							} else {
								fileName.textContent = '';
							}
						});
					});
				});
			}
		};

		const ajaxNonce = ajaxload_params.nonce; //eslint-disable-line
		xhr.send(
			`action=filter_current_openings&post_type=careers&teams=${cmbteams}&country=${cmbcountry}&exp=${cmbexp}&hdnAttributes=${hdnAttributes}&nonce=${ajaxNonce}`,
		);
	}

	const currentOpenings = document.querySelectorAll('.current-opening-dropdown.item');
	currentOpenings.forEach(currentOpening => {
		const openingContainer = currentOpening.querySelector('.opening-container');
		openingContainer.addEventListener('click', () => {
			const clsIna = currentOpening.querySelector('.detail-container').classList;
			if (clsIna.contains('inactive')) {
				currentOpening.querySelector('.detail-container').classList.remove('inactive');
				currentOpening.querySelector('.carat-sign').classList.add('open');
				currentOpening.classList.add('open-dropdown');
			} else {
				currentOpening.querySelector('.detail-container').classList.add('inactive');
				currentOpening.querySelector('.carat-sign').classList.remove('open');
				currentOpening.classList.remove('open-dropdown');
			}
		});
	});

	const loadMore = document.querySelector('.load-more');
	if (loadMore) {
		loadMore.addEventListener('click', event => {
			let cnt = 0;
			event.preventDefault();
			while (cnt < 5) {
				const row = document.querySelector('.current-opening-dropdown.inactive');
				if (row !== null) {
					document.querySelector('.current-opening-dropdown.inactive').classList.remove('inactive');
				} else {
					console.error("Element with class 'my-class' not found.");
					document.querySelector('.openings-button').classList.add('inactive');
				}
				cnt += 1;
			}
		});
	}
	const cmblocation = document.querySelectorAll('.input-filter select');
	cmblocation.forEach(cmbdrp => {
		cmbdrp.addEventListener('change', event => {
			event.preventDefault();
			getCurrentOpeningsById();
		});
	});
});
